import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>January Wine Dinner</h1>
                <h2 className={classes.bold}>
                  January 8th <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $65 Per Guest
                </h2>
                <h3>Hosted by Alabama Crown</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>

          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>
                <h5>First Course</h5>
                <h4>Red Fish Ceviche</h4>
                <p>Fried Wonton Bowl, Bell Peppers, Onions, Cucumber, Fresh Herbs, and Citrus Marinade</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Bezel Wines · Paso Robles Sauvignon Blanc · California 2024</h4>
              </div>
 
              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>New Orleans Style Toasted Ravioli</h4>
                <p>Roasted Asiago Cream Sauce, Stuffed with Crawfish and Sausage</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Gravel Bar Winery · Alluvial Red Blend · Washington NV</h4>
              </div>
              
              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Maple Brown Sugar Lamb Chops</h4>
                <p>Duchess Whipped Potatoes, Sautéed Brussels Sprouts and Caramelized Onions</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Trapiche · Cabernet Sauvignon Blanc · Tesoro Valle de Uco · Argentina NV</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Pomegranate Panna Cotta</h4>
                <p>Grand Mariner Cream Sauce</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Banshee · Méthode Champenoise Brut Ten-Of-Cups · California NV</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner